import React from 'react';

/**
 * PublicRoute component that allows access to public marketing pages
 *
 * Unlike GuestRoute (redirects authenticated users) or ProtectedRoute (redirects unauthenticated users),
 * PublicRoute allows BOTH authenticated and unauthenticated users to access the page.
 *
 * This is used for marketing pages like:
 * - Homepage (/)
 * - Pricing (/pricing)
 * - Privacy Policy (/privacy)
 * - Terms of Service (/terms)
 * - Cookie Policy (/cookies)
 *
 * Components inside can check authentication status to show different content:
 * - Authenticated users: "Go to Dashboard" button
 * - Unauthenticated users: "Start Free Trial" button
 */
export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // No authentication checks - allow everyone
  return <>{children}</>;
};

PublicRoute.displayName = 'PublicRoute';
